import React from 'react';

const OrderFormModal = React.lazy(() => import('../components/FormModal'));
const orderModalRegistry = {
    core_orderId: OrderFormModal
};
export default orderModalRegistry;
